// extracted by mini-css-extract-plugin
module.exports = {"inner":"commercial_notice_inner__XNHU_","title":"commercial_notice_title__Bjt_Y","item":"commercial_notice_item__mb7pc"};